import { type FC } from 'react'

interface PreviewLabelProps {
  stacked?: boolean
  shownToClients?: boolean
  showStatus?: boolean
}

export const PreviewLabel: FC<PreviewLabelProps> = ({ stacked = false, shownToClients = true, showStatus = true }) => {
  const icon = shownToClients ? 'bi bi-eye' : 'bi bi-eye-slash'
  const label = shownToClients ? 'Shown to clients' : 'Not shown to clients'
  return stacked ? (
    <div className='d-flex flex-column zocks-text-gray-600'>
      <span className='d-flex align-items-center zocks-gap-0.5 lead-small text-uppercase'>
        <i className={icon} />
        Preview
      </span>
      {showStatus ? <span className='paragraph-small'>{label}</span> : null}
    </div>
  ) : (
    <span className='d-flex align-items-center zocks-gap-0.5 zocks-text-gray-600'>
      <i className={icon} />
      <span className='lead-small text-uppercase'>Preview</span>
      {showStatus ? (
        <>
          <span>·</span>
          <span className='paragraph-small'>{label}</span>
        </>
      ) : null}
    </span>
  )
}
